/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Research_Limit_3_ValueInputs */

const en_svc_research_limit_3_value = /** @type {(inputs: Svc_Research_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Each run has a budget, and every search is recorded.`)
};

const lv_svc_research_limit_3_value = /** @type {(inputs: Svc_Research_Limit_3_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katrai palaišanai ir budžets, un katrs meklējums tiek pierakstīts.`)
};

/**
* | output |
* | --- |
* | "Each run has a budget, and every search is recorded." |
*
* @param {Svc_Research_Limit_3_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_research_limit_3_value = /** @type {((inputs?: Svc_Research_Limit_3_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Research_Limit_3_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_research_limit_3_value(inputs)
	return en_svc_research_limit_3_value(inputs)
});